<template>
  <div class="image-viewer">
    <div class="toolbar">
      <button @click="zoomIn">+</button>
      <button @click="zoomOut">−</button>
      <button @click="reset">↺</button>
    </div>
    <div
      class="viewport"
      @wheel.prevent="onWheel"
      @mousedown="startDrag"
      @mousemove="drag"
      @mouseup="stopDrag"
      @mouseleave="stopDrag"
    >
      <img
        :src="src"
        :style="imageStyle"
        draggable="false"
        alt="image"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageZoom',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      scale: 1,
      x: 0,
      y: 0,
      dragging: false,
      startX: 0,
      startY: 0
    }
  },
  computed: {
    imageStyle () {
      return {
        transform: `translate(${this.x}px, ${this.y}px) scale(${this.scale})`,
        cursor: this.dragging ? 'grabbing' : 'grab',
        transformOrigin: 'top left'
      }
    }
  },
  methods: {
    zoomIn () {
      this.scale = Math.min(this.scale + 0.2, 5)
    },
    zoomOut () {
      this.scale = Math.max(this.scale - 0.2, 0.5)
    },
    reset () {
      this.scale = 1
      this.x = 0
      this.y = 0
    },
    onWheel (event) {
      const factor = event.deltaY < 0 ? 0.1 : -0.1

      this.scale = Math.min(
        5,
        Math.max(0.5, this.scale + factor)
      )
    },
    startDrag (event) {
      this.dragging = true
      this.startX = event.clientX - this.x
      this.startY = event.clientY - this.y
    },
    drag (event) {
      if (!this.dragging) return

      this.x = event.clientX - this.startX
      this.y = event.clientY - this.startY
    },
    stopDrag () {
      this.dragging = false
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: absolute;
  right: 16px;
  bottom: 16px;

  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1000;
}

.toolbar button {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  cursor: pointer;

  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.image-viewer {
  width: 65%;
  height: 60vh;
  position: relative;
  margin: auto;
}

.toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.viewport {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  overflow: hidden;
}

.viewport img {
  max-width: 100%;
  max-height: 100%;
}

</style>
